import { useCallback, useEffect, useLayoutEffect, useState } from "react";

export const RAIL_KEY = "hub.rail";
export const APP_ROOT_ID = "app-root";

function readRail(): boolean {
  try {
    return localStorage.getItem(RAIL_KEY) === "1";
  } catch {
    return false;
  }
}

function writeRail(on: boolean): void {
  try {
    localStorage.setItem(RAIL_KEY, on ? "1" : "0");
  } catch {
    // storage can be denied; the toggle must still work
  }
}

const TEXT_ENTRY = "input, textarea, select, [contenteditable=''], [contenteditable='true']";

function isTextEntry(target: EventTarget | null): boolean {
  const el = target as Element | null;
  return typeof el?.closest === "function" && el.closest(TEXT_ENTRY) !== null;
}

export function useRail(): { railed: boolean; toggle: () => void } {
  const [railed, setRailed] = useState(readRail);
  const toggle = useCallback(() => setRailed((on) => !on), []);

  // layout effect: a remembered rail is applied before the first paint, not after it
  useLayoutEffect(() => {
    document.getElementById(APP_ROOT_ID)?.classList.toggle("is-rail", railed);
  }, [railed]);

  useEffect(() => writeRail(railed), [railed]);

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === "[" && !isTextEntry(e.target)) toggle();
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [toggle]);

  return { railed, toggle };
}
